import editSubjectPlanEn from "./locales/en.json";

export const EDIT_SUBJECT_PLAN_NS = "editSubjectPlan" as const;

export const EditSubjectPlanTranslations = {
  en: {
    [EDIT_SUBJECT_PLAN_NS]: {
      ...editSubjectPlanEn,
    },
  },
};
